import React from "react";
import cx from "classnames";
import isInteger from "lodash/isInteger";
import PropTypes from "prop-types";

import Unit from "components/Unit";
import { getFallbackLocale } from "utils/locale";

import styles from "./Size.css";

const Size = (props) => {
  const { hidePlaceholder, isLarge, isUnitBlack, primaryValue } = props;
  const isRange = (props.value || 0).toString() !== (props.value2 || 0).toString();

  const separator = props.separator ? " - " : <span className={styles.separator} />;
  const value =
    props.value && parseInt(props.value, 10) !== 0 ? (
      <span className={cx(styles.value, { [styles.bold]: props.isValueBold })}>
        {typeof props.value === "string"
          ? props.value
          : props.value.toLocaleString(getFallbackLocale(), {
              maximumFractionDigits: 2,
            })}
      </span>
    ) : null;

  const value2 =
    props.value2 && parseInt(props.value2, 10) !== 0 ? (
      <span>
        {value ? separator : null}
        <span className={styles.value}>
          {typeof props.value2 === "string"
            ? props.value2
            : props.value2.toLocaleString(getFallbackLocale(), {
                maximumFractionDigits: 2,
              })}
        </span>
      </span>
    ) : null;

  const unit = props.unit && (
    <Unit
      isBlack={isUnitBlack}
      unit={props.unit}
      value={
        props[primaryValue] || (props.value && isInteger(props.value) ? props.value : props.value2)
      }
    />
  );

  return (
    <div className={cx(styles.root, { [styles.large]: isLarge })}>
      {value || value2 ? (
        <>
          {value}
          {isRange && value2}
          {unit}
        </>
      ) : (
        !hidePlaceholder && "-"
      )}
    </div>
  );
};

Size.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  unit: PropTypes.string.isRequired,
  primaryValue: PropTypes.oneOf(["value", "value2"]),
  isLarge: PropTypes.bool,
  isValueBold: PropTypes.bool,
  isUnitBlack: PropTypes.bool,
  separator: PropTypes.string,
  hidePlaceholder: PropTypes.bool,
};

Size.defaultProps = {
  value: "",
  value2: "",
  unit: "",
};

export default Size;
